import XLSX from 'xlsx';

export default {
	s2ab(s) { //字符串转字符流
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	},
	getCharCol(n) {
		let temCol = '',
			s = '',
			m = 0
		while (n > 0) {
			m = n % 26 + 1
			s = String.fromCharCode(m + 64) + s
			n = (n - m) / 26
		}
		return s
	},
	saveAs(obj, fileName) { //导出功能实现
		var tmpa = document.createElement("a");
		tmpa.download = fileName || "下载";
		tmpa.href = URL.createObjectURL(obj); //绑定a标签
		tmpa.click(); //模拟点击实现下载
		setTimeout(() => { //延时释放
			URL.revokeObjectURL(obj); //用URL.revokeObjectURL()来释放这个object URL
		}, 100);
	},
	exportFile(json, fileName) {
		const type = 'xlsx' //定义导出文件的格式
		var tmpDown; //导出的内容
		var tmpdata = json[0];
		json.unshift({});
		var keyMap = []; //获取keys
		for (var k in tmpdata) {
			keyMap.push(k);
			json[0][k] = k;
		}
		var tmpdata = []; //用来保存转换好的json 

		json.map((v, i) => keyMap.map((k, j) => Object.assign({}, {
			v: v[k],
			position: (j > 25 ? this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
		}))).reduce((prev, next) => prev.concat(next)).forEach((v, i) => tmpdata[v.position] = {
			v: v.v
		});
		var outputPos = Object.keys(tmpdata); //设置区域,比如表格从A1到D10
		var tmpWB = {
			SheetNames: ['sheet1'], //保存的表标题
			Sheets: {
				'sheet1': Object.assign({},
					tmpdata, //内容
					{
						'!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] //设置填充区域
					})
			}
		};
		tmpDown = new Blob([this.s2ab(XLSX.write(tmpWB, {
				bookType: (type == undefined ? 'xlsx' : type),
				bookSST: false,
				type: 'binary'
			} //这里的数据是用来定义导出的格式类型
		))], {
			type: ""
		}); //创建二进制对象写入转换好的字节流
		this.saveAs(tmpDown, fileName);
	},

	//导入excel
	onImportExcel(file, isBinary = true) {
		console.log(file);
		return new Promise((resolve, reject) => {
			// 通过FileReader对象读取文件
			const fileReader = new FileReader();

			FileReader.prototype.readAsBinaryString = function(file) {
				var binary = "";
				var rABS = false; //是否将文件读取为二进制字符串
				var pt = this;
				var wb; //读取完成的数据
				var outdata;
				var reader = new FileReader();
				reader.onload = function(e) {
					var bytes = new Uint8Array(reader.result);
					var length = bytes.byteLength;
					for (var i = 0; i < length; i++) {
						binary += String.fromCharCode(bytes[i]);
					}
					// var XLSX = require('xlsx');
					if (!isBinary) {
						wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
							type: 'base64'
						});
					} else {
						wb = XLSX.read(binary, {
							type: 'binary'
						});
					}
					outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
					resolve(outdata);
				}
				reader.readAsArrayBuffer(file);
			}
			// 以二进制方式打开文件
			if (isBinary) {
				fileReader.readAsBinaryString(file);
			} else {
				fileReader.readAsArrayBuffer(file);
			}

		});
	},
	fixdata(data) { //文件流转BinaryString
		var o = "",
			l = 0,
			w = 10240;
		for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l *
			w + w)));
		o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
		return o;
	}
}



// WEBPACK FOOTER //
// ./src/utils/xlsxTool.js